export enum CriteriaType {
  EXTERIOR_AUTO_DIMENSION = "EXTERIOR_AUTO_DIMENSION",
  FOUNDATION_EXTERIOR_AUTO_DIMENSION = "FOUNDATION_EXTERIOR_AUTO_DIMENSION",
  FOUNDATION_INTERIOR_AUTO_DIMENSION = "FOUNDATION_INTERIOR_AUTO_DIMENSION",
  INTERIOR_AUTO_DIMENSION = "INTERIOR_AUTO_DIMENSION",
}
